import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import axios from 'axios'
import serve from "@/service/api";
// import BaiduMap from "vue-baidu-map";
import store from "./store";
import Vue2TouchEvents from "vue2-touch-events";
import VueWechatTitle from "vue-wechat-title";
import "./utils/element-ui";
import "element-ui/lib/theme-chalk/index.css";

const uc_mb_hostName = "https://uc.todesk.com/mobile";
const daas_www_hostName = 'https://daas-personal.todesk.com/mobile';

Vue.prototype.$store = store;
Vue.prototype.$serve = serve;
Vue.prototype._uc_mb_hostName = uc_mb_hostName;
Vue.prototype._daas_www_hostName = daas_www_hostName;
Vue.config.productionTip = false;

Vue.use(VueWechatTitle);
// Vue.use(BaiduMap, {
//   ak: "YkUgliT0IjdeA5ZxKdErqDKqHztILxO4",
// });
Vue.use(Vue2TouchEvents,{
  touchHoldTolerance: 2000,
  swipeTolerance: 100,
  longTapTimeInterval: 100
});
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
